import React from 'react';
import ReactTable from 'react-table';
import withFixedColumns from 'react-table-hoc-fixed-columns';

import {CurrencyUtil} from '@aperza/util';

import { createRefetchContainer, graphql } from 'react-relay';
import AppConfig from '../domain/AppConfig';
import AppService from '../service/AppService';
import {Message} from '@aperza/ui';
import ReactTooltip from 'react-tooltip';

import SellerGroupModelListPagination from './SellerGroupModelListPagination';

import SellerShippingTooltip from './SellerShippingTooltip';

import { withTranslation } from 'react-i18next';

import { faWeightHanging, faShoppingBag } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {isMobile} from 'react-device-detect';
import WebMediaQuery from './WebMediaQuery';

const appConfig:AppConfig = AppService.appConfig();

const ReactTableFixedColumns = withFixedColumns(ReactTable);

class SellerShippingPrice extends React.Component {

  sortedBaseShippingFeesColumns = new Set();
  sortedAdditionalShippingFeesWeightColumns = new Set();
  sortedAdditionalShippingFeesQuantityColumns = new Set();

  // FUNCTIONS here
  sortLocationsData(locations, renderedTexts){
    /// TODO : Sort Base Shipping Fees

    return locations.map(location => {
      /// TODO : BASE SHIPPING FEES
      let baseShippingFees = new Object();
      location.baseShippingFees.forEach(fee => {
        this.sortedBaseShippingFeesColumns.add(CurrencyUtil.parseCurrency(fee.priceFrom)+"~"+((fee.priceTo)?CurrencyUtil.parseCurrency(fee.priceTo):renderedTexts.unlimited));
        baseShippingFees[CurrencyUtil.parseCurrency(fee.priceFrom)+"~"+((fee.priceTo)?CurrencyUtil.parseCurrency(fee.priceTo):renderedTexts.unlimited)] = (fee.shippingFee>0)?CurrencyUtil.parseCurrency(fee.shippingFee, true):fee.shippingFee;
      });

      /// TODO : additional Shipping Fee for the weight
      let additionalShippingFeesWeight = location.additionalShippingFeesWeight.map(fee => {
        this.sortedAdditionalShippingFeesWeightColumns.add("id_w_"+fee.shippingPlanDisplayId);
        return {
          shippingPlanDisplayId: fee.shippingPlanDisplayId,
          referenceWeight: fee.referenceWeight,
          shippingFeePerAdditionalKilo: fee.shippingFeePerAdditionalKilo,
          shippingFee: fee.shippingFee
        }
      });

      /// TODO : additional Shipping Fee for the quantity
      let additionalShippingFeesQuantity = location.additionalShippingFeesQuantity.map(fee => {
        this.sortedAdditionalShippingFeesQuantityColumns.add("id_q_"+fee.shippingPlanDisplayId);
        return {
          shippingPlanDisplayId: fee.shippingPlanDisplayId,
          shippingFeePerAdditionalQuantity: fee.shippingFeePerAdditionalQuantity,
          shippingFee: fee.shippingFee
        }
      });

      return {
        locationCode: location.locationCode,
        locationName: location.locationName,
        baseShippingFees: baseShippingFees,
        additionalShippingFeesWeight: additionalShippingFeesWeight,
        additionalShippingFeesQuantity: additionalShippingFeesQuantity
      };

    });

  }

  createColumns(cols) {

    this.columns = [{
      Header: <Message messageId="seller.shippingFee.heading" />,
      id: "prefecture",
      accessor: (d) => d,
      Cell: props =>
        <React.Fragment>
          <WebMediaQuery desktopOnly={true}>
            <div>{props.value.locationName}
            <SellerShippingTooltip shippingInfo={props.value} shippingType="weight" />
            <SellerShippingTooltip shippingInfo={props.value} shippingType="quantity" />
            </div>
          </WebMediaQuery>
        </React.Fragment>,
      width: 250,
      fixed: 'left'
    }];

    // Assigning Columns
    let baseShippingFeesHeadings = []
    this.sortedBaseShippingFeesColumns.forEach((col, index) => {
      baseShippingFeesHeadings.push({
        Header: col,
        id: "baseShipping_"+index,
        accessor: (d) => (d.baseShippingFees[col]!=0)?d.baseShippingFees[col]:<Message messageId="seller.shippingFee.free" />,
        // width: 150,
      });
    });
    this.columns.push({
      accessor: (d) => d.baseShippingFees,
      columns: baseShippingFeesHeadings
    });

    return this.columns;
  }

  // CONSTRUCTOR
  constructor(props) {
    super(props);

    this.columns = [];
    this.data = [];
    this.state = {
      sellerContactId:  this.props.sellerContactId,
      overseas: this.props.overseas,
    };

  }

  componentDidUpdate() {
    // ReactTooltip.rebuild();
  }

  render() {

    const t = this.props.t;

    let getRawDatas = this.props.sellerShippingPriceResponseData.calculateSellerShippingPrice;

    if (!getRawDatas) {
      console.log('Data is empty, not returning any seller shipping prices')
      return (null);
    }

    let renderedTexts = {
      unlimited: t('seller.shippingFee.unlimited'),
    };

    // console.log("sortLocationsData", getRawDatas);

    this.data = this.sortLocationsData(getRawDatas.locations, renderedTexts);

    // console.log("sortedBaseShippingFeesColumns",this.sortedBaseShippingFeesColumns);
    // console.log("sortedAdditionalShippingFeesWeightColumns",this.sortedAdditionalShippingFeesWeightColumns);
    // console.log("sortedAdditionalShippingFeesQuantityColumns",this.sortedAdditionalShippingFeesQuantityColumns);

    // Rendering begin
    console.log("this.data", this.data);
    if ( this.data && this.data.length > 0 ) {

      if (!isMobile) {
        return (
          <div>
            <ReactTableFixedColumns
              data={this.data}
              columns={this.createColumns(this.data.columns)}
              sortable={false}
              resizable={false}
              footer={false}
              className="shipping-fee-table table-vh-hover -highlight"
              PaginationComponent={SellerGroupModelListPagination}
              showPageSizeOption={false}
              showPageJump={false}
              defaultPageSize={10}
            />
          </div>
        );
      } else {

        return this.data.map((prefecture, index) => {
          let tableData = this.sortedBaseShippingFeesColumns.map((col, index) => {
            return (
              <tr key={"mtrow_"+index}>
                <td>{col}</td>
                <td>{prefecture.baseShippingFees[col]?prefecture.baseShippingFees[col]:<Message messageId="seller.shippingFee.free" />}</td>
              </tr>
            );
          });

          return (
            <div className="shipping-fee-group-mobile" key={"pref"+index}>
              <h2>{prefecture.locationName}</h2>
              <table>
                <thead>
                  <tr>
                    <th>
                      <React.Fragment>
                        <Message messageId="seller.shippingFee.heading" />
                        <SellerShippingTooltip shippingInfo={prefecture} shippingType="weight" />
                      </React.Fragment>
                    </th>
                    <th>
                      <React.Fragment>
                        <Message messageId="seller.shippingFee.shippingFee" />
                        <SellerShippingTooltip shippingInfo={prefecture} shippingType="quantity" />
                      </React.Fragment>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {tableData}
                </tbody>
              </table>
            </div>
          );
        });
      }
    } else {
      console.log("No Shipping Price Data Found");
      return (null);
    }
  }

  _refetch = (state, instance) => {
    // this.setState({ loading: true});
    this.props.relay.refetch(
      {
        sellerContactId: state.sellerContactId,
        overseas: (state.overseas =="true")
      },
      null,  // We can use the refetchVariables as renderVariables
      (error) => {
        console.log('Finished fetching');
        // this.setState({ loading: false});
      },
      { force: false }  // Assuming we've configured a network layer cache, we want to ensure we fetch the latest data.
    );
  };
}

export default createRefetchContainer(
  withTranslation()(SellerShippingPrice),
  {
    sellerShippingPriceResponseData: graphql`
        fragment SellerShippingPrice_sellerShippingPriceResponseData on SellerShippingPriceSchemaType
        @argumentDefinitions(
          sellerContactId: {type: "String"},
          overseas: {type: "Boolean"}
        ),
        {
          calculateSellerShippingPrice(
            sellerContactId: $sellerContactId, 
            overseas: $overseas
          ){
            locations {
              locationCode
              locationName
              baseShippingFees {
                locationCode
                locationName
                priceFrom
                priceTo
                shippingFee
              }
              additionalShippingFeesWeight {
                locationCode
                locationName
                referenceWeight
                shippingFee
                shippingFeePerAdditionalKilo
                shippingPlanDisplayId
              }
              additionalShippingFeesQuantity {
                locationCode
                locationName
                shippingFee
                shippingFeePerAdditionalQuantity
                shippingPlanDisplayId
              }
            } 
          }
        }
    `
  },
  graphql`
      query SellerShippingPriceRefetchQuery(
        $sellerContactId:String,
        $overseas:Boolean
      ) {
        calculateSellerShippingPrice {
              ...SellerShippingPrice_sellerShippingPriceResponseData @arguments(
                sellerContactId: $sellerContactId,
                overseas: $overseas)
        }
      }
  `
);
